export default __webpack_public_path__ + "static/media/giphy.439ea80d.png";